import * as Yup from "yup";

export const cityValidationSchema = Yup.object().shape({
  city_name: Yup.string()
    .trim()
    .min(2, "City name must be at least 2 characters")
    .max(100, "City name cannot exceed 100 characters")
    .required("City name is required"),

  province_id: Yup.string().trim().required("Please select a province"),

  country_id: Yup.string().trim().required("Please select a country"),
});

